import { Component, Input, EventEmitter, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'digi-number',
  templateUrl: './input-number.component.html',
  styleUrl: './input-number.component.scss'
})
export class InputNumberComponent {
  @Input() label: string = 'Nhập số';
  @Input() placeholder: string = '';
  @Input() control!: FormControl;
  @Input() errorMessage: string = '';
  @Input() errorMessagePhone: string = '';
  @Output() onChangeValue = new EventEmitter<number>(); 
  @Input() isSubmit: boolean = false;
  @Input() isMinLengthRequired: boolean = false;
  @Input() isMaxLengthRequired: boolean = false;
  @Input() minLength: number = 0;
  @Input() maxLength: number = 10;
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const numericValue = input.value.replace(/[^0-9]/g, ''); // Loại bỏ ký tự không phải số
    input.value = numericValue; // Cập nhật lại giá trị
    this.control.setValue(numericValue); // Đồng bộ với FormControl
  }

  onBlur(){
    this.onChangeValue.emit(this.control.value);
  }
  
}
